@if (latestReviews && latestReviews.length > 0) {
  <div class="latest_reviews_price outer_seo_page_component_container">
    <div class="width_wrapper inner_seo_page_component_container">
      <h2 class="desktop_h2 vertical_h2">
        {{ 'COMPONENTS.PRICE_REVIEW.REV' | translate }}
      </h2>
      <div class="review_grid">
        <div>
          <h2 class="mobile_h2 vertical_h2">
            {{ 'COMPONENTS.PRICE_REVIEW.REV' | translate }}
          </h2>
          <app-review-grid [reviews]="latestReviews"> </app-review-grid>
        </div>
        <div class="price_rating_column">
          <app-price-average
            [priceLow]="q25Price!"
            [priceMedium]="q50Price!"
            [priceHigh]="q75Price!"
            title="{{ 'PAGES.VERTICAL.AVG_PRICE' | translate }} {{
              vertical?.sPM
            }}"
            [priceGuideLink]="getPriceGuideURL()"
            [showCreateTaskButton]="true"
            [createTaskTitleLabel]="$safeNavigationMigration(vertical?.h1)"
          >
          </app-price-average>
          <app-review-overview
            [reviewCount]="reviewCount"
            [verticalName]="vertical.sPM"
          >
          </app-review-overview>
        </div>
      </div>
      <div [innerHTML]="taskSchema | jsonLd"></div>
    </div>
  </div>
}
